module.exports = __webpack_public_path__ + "img/logo.c314f14f.png";